// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ff4024d","453":"60173029","455":"25ba6fe4","601":"301346c5","758":"a62f7a69"}[chunkId] + ".chunk.js";
};